import { memo } from "react";
import AbstractStandardNode from "../../customNodeTypes/AbstractStandardNode";

export default memo(({ type }: any) => {
    return <AbstractStandardNode label={""} type={type}></AbstractStandardNode>;
});
